import {inject, Injectable} from "@angular/core";
import {EVENT_BUS} from "../../../../../shared/domain/tokens/event-bus.token";
import {AccountStoreService} from "../services/account-store.service";
import {Entry} from "../../../entry/domain/model/entry.model";
import {EntriesAction} from "../../../../../shared/application/events/entry/entries-changed.event";
import {first, map, Observable} from "rxjs";
import {filter, tap} from "rxjs/operators";
import {Account} from "../../domain/model/account.model";
import {
  AccountEntriesAppliedEvent
} from "../../../../../shared/application/events/account/account-entries-applied.event";

@Injectable({providedIn: 'root'})
export class ApplyAccountEntriesUseCase {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly accountStore = inject(AccountStoreService);

  execute(entries: readonly Entry[], action: EntriesAction): Observable<void> {
    return this.accountStore.getSelectedAccount$().pipe(
      first(),
      filter((account): account is Account => !!account),
      tap(account => this.applyEntries(account, entries, action)),
      tap(account => this.publishApplied(account)),
      map(() => void 0)
    );
  }

  private applyEntries(account: Account, entries: readonly Entry[], action: EntriesAction): void {
    const actions: Record<EntriesAction, (entry: Entry) => void> = {
      added: entry => account.addEntry(entry),
      updated: entry => account.updateEntry(entry),
      removed: entry => account.removeEntry(entry),
    };

    entries.forEach(actions[action]);
    this.accountStore.saveSelectedAccount(account);
  }

  private publishApplied(account: Account): void {
    this.eventBus.publish(new AccountEntriesAppliedEvent(account));
  }
}
